import React from "react";
import BackgroundImage from "gatsby-background-image";

export default function BannerImage({
  childImageSharp /**
      childImageSharp {
        fluid(quality: 90, maxWidth: 1920) {
          ...GatsbyImageSharpFluid
        }
      }
    */,
}) {
  if (childImageSharp?.fluid) {
    return (
      <BackgroundImage
        Tag="div"
        className="w-full h-banner post-banner"
        fluid={childImageSharp.fluid}
      ></BackgroundImage>
    );
  } else {
    return <div className="w-full h-banner post-banner bg-primary" />;
  }
}
